<div class="container">
  <div class="row">
    <div class="col">
    </div>
    <div class="col" style="background-color: white;">
      <iframe class="p-col p-ai-center p-jc-center" [src]="externalPageURL | safe" frameborder="0" style="width: 100%"></iframe>
    </div>
  </div>
</div>
